import React from 'react';

interface PackingRequirementsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PackingRequirementsModal: React.FC<PackingRequirementsModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="packing-modal-overlay" onClick={onClose}>
      <div className="packing-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="packing-modal-header">
          <h3>Packing Requirements</h3>
          <button
            type="button"
            onClick={onClose}
            className="packing-modal-close-btn"
          >
            Close
          </button>
        </div>

        <div className="packing-modal-body">
          <div className="packing-section">
            <h4 className="packing-rules-title">Packing Rules</h4>
            <ul className="packing-list">
              <li>
                Use <strong>strong, double-walled cardboard boxes</strong>
              </li>
              <li>
                <strong>Label clearly</strong> and <strong>seal securely</strong>
              </li>
              <li>
                Items <strong>must not move</strong> inside
              </li>
            </ul>
          </div>

          <hr className="packing-divider" />

          <div className="packing-section">
            <h4 className="packing-forbidden-title">🚫 Restricted Items</h4>
            <ul className="packing-list">
              <li>Liquids, food, chemicals</li>
              <li>Fragile or sharp items (unless well-packed)</li>
              <li>Electronics/appliances (unless original packaging)</li>
              <li>Jewellery or antiques</li>
            </ul>
          </div>

          <hr className="packing-divider" />

          <div className="packing-section">
            <h4 className="packing-warning-title">⚠️ Not Accepted</h4>
            <ul className="packing-list">
              <li>Weak/plastic boxes, bags, or unboxed items</li>
              <li>Soft-case instruments</li>
              <li>
                Items over <strong>25 kg</strong> or <strong>75×55×55 cm</strong>
              </li>
            </ul>
          </div>

          <div className="packing-link-container">
            <p>
              For more details, please visit our{' '}
              <a
                href="https://www.kitkeeper.co.uk/packing-guide"
                target="_blank"
                rel="noreferrer"
                className="packing-guide-link"
              >
                Packing Guide
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackingRequirementsModal;

